// @flow
import React from "react"
import Snackbar from "material-ui/Snackbar"
import {containers} from "@swarm2/core"
import * as Util from "../common"
import onlyUpdateForKeys from "recompose/onlyUpdateForKeys"
import withProps from "recompose/withProps"
import compose from "recompose/compose"

const M = Util.intlMessages("view.AchievementsToast")
const AM = Util.intlMessages("achievements")

export const AchievementsToastRender = (props: Object) => {
  const {first, onRequestClose, autoHideDuration = 6000, error} = props
  //console.log("toast", {first, onRequestClose, autoHideDuration, error})
  if (error) return null
  if (!first) return null
  //  action='view' onActionClick={history.push('/p/')}
  return (
    <Snackbar
      {...{open: !!first, autoHideDuration, onRequestClose}}
      message={
        <span>
          <M id="title" values={{displayName: <AM id={first} />}} />
        </span>
      }
    />
  )
}

export default compose(
  containers.achievements.AchievementsToast,
  onlyUpdateForKeys(["first", "autoHideDuration", "error"]),
  withProps(
    props =>
      !props.error && {
        onRequestClose: reason => {
          if (reason !== "clickaway") return props.onRequestClose()
        },
      },
  ),
)(AchievementsToastRender)



// WEBPACK FOOTER //
// ./src/achievements/AchievementsToastView.js